import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AutocompleteBottomSheet } from './AutocompleteBottomSheet';
export function deriveAutocompleteDisplayValue(props) {
    if (props.multiple && Array.isArray(props.value)) {
        return props.value.map((v)=>{
            var _props_getOptionLabel;
            return ((_props_getOptionLabel = props.getOptionLabel) !== null && _props_getOptionLabel !== void 0 ? _props_getOptionLabel : String)(v);
        }).join(', ');
    }
    if (props.value != null) {
        var _props_getOptionLabel;
        return ((_props_getOptionLabel = props.getOptionLabel) !== null && _props_getOptionLabel !== void 0 ? _props_getOptionLabel : String)(props.value);
    }
    return '';
}
export function buildAutocompleteBottomSheet(props) {
    return /*#__PURE__*/ _jsx(AutocompleteBottomSheet, {
        options: props.options,
        getOptionLabel: props.getOptionLabel,
        renderOption: props.renderOption,
        filterOptions: props.filterOptions,
        getOptionDisabled: props.getOptionDisabled,
        getOptionSelected: props.getOptionSelected,
        onChange: props.onChange,
        value: props.value,
        inputValue: props.inputValue,
        multiple: props.multiple,
        freeSolo: props.freeSolo,
        filterSelectedOptions: props.filterSelectedOptions,
        loading: props.loading,
        noOptionsText: props.noOptionsText,
        label: props.label,
        testId: props.testId,
        disableCloseOnSelect: props.disableCloseOnSelect
    });
}
